import React from 'react'

const Logo = ({
  style,
  width,
  className,
  height,
  viewBox,
  dark,
  light,
  props,
}) => {
  const prefersDarkMode = false //useMediaQuery('(prefers-color-scheme: dark)');

  if (dark) {
    return LogoDark({
      style,
      width,
      className,
      height,
      viewBox,
      dark,
      light,
      props,
    })
  }

  if (light) {
    LogoLight({
      style,
      width,
      className,
      height,
      viewBox,
      dark,
      light,
      props,
    })
  }

  return prefersDarkMode
    ? LogoDark({
        style,
        width,
        className,
        height,
        viewBox,
        dark,
        light,
        props,
      })
    : LogoLight({
        style,
        width,
        className,
        height,
        viewBox,
        dark,
        light,
        props,
      })
}

const LogoLight = ({
  style = {},
  width = '171px',
  className = '',
  height = '61px',
  viewBox = '0 0 171 61',
  dark,
  light,
  props,
}) => {
  const logo = (
    <svg
      width={width}
      style={style}
      height={height}
      viewBox={viewBox}
      className={className}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-labelledby="title"
      role="img"
    >
      <title id="title">Mundi logo</title>
      <g
        transform="translate(10 7)"
        filter="url(#logoFilter)"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(140.564 .1)">
          <mask fill="#fff">
            <filter
              x="-1.6%"
              y="-27.7%"
              width="103.2%"
              height="155.4%"
              filterUnits="objectBoundingBox"
              id="logoFilter"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur
                stdDeviation="5"
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
              />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.162259615 0"
                in="shadowBlurOuter1"
                result="shadowMatrixOuter1"
              />
              <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <path d="M.155.082h10.561v10.557H.155z" />
          </mask>
          <path
            d="M10.716 5.36a5.28 5.28 0 0 1-5.283 5.279A5.26 5.26 0 0 1 1.585 8.97 5.278 5.278 0 0 1 5.434.081a5.28 5.28 0 0 1 5.282 5.28"
            fill="#F05A26"
            mask="url(#c)"
          />
        </g>
        <path
          d="M108.545 27.353v13.503h-8.339V27.353a5.159 5.159 0 0 0-10.315 0v13.503h-8.35V27.353c0-7.45 6.04-13.502 13.502-13.502 7.462 0 13.502 6.051 13.502 13.502"
          fill="#404042"
        />
        <path
          d="M18.647 40.856V27.353c0-.12.001-.24.004-.36a5.157 5.157 0 0 0-5.148-4.792 5.156 5.156 0 0 0-5.153 5.152v13.503H0V27.353c0-7.45 6.04-13.502 13.503-13.502 3.617 0 6.9 1.422 9.323 3.736a13.452 13.452 0 0 1 9.324-3.736c7.461 0 13.502 6.051 13.502 13.502v13.503h-8.34V27.353a5.158 5.158 0 0 0-10.31-.233c.002.078.003.155.003.233v13.503h-8.358z"
          fill="#F05A26"
        />
        <path
          d="M50.093 28.464V14.96h8.34v13.503a5.158 5.158 0 0 0 10.315 0V14.96h8.35v13.503c0 7.45-6.04 13.502-13.502 13.502-7.462 0-13.503-6.052-13.503-13.502m91.73 12.393h8.351V13.85h-8.35zm-15.722 0h-13.114v-8.34H126.1a5.159 5.159 0 0 0 0-10.315h-13.114v-8.35H126.1c7.45 0 13.502 6.04 13.502 13.502 0 7.462-6.051 13.503-13.502 13.503"
          fill="#404042"
        />
      </g>
    </svg>
  )

  return logo
}

const LogoDark = ({
  style = {},
  width = '152px',
  className = '',
  height = '42px',
  viewBox = '0 0 152 42',
  dark,
  light,
  props,
}) => {
  const logo = (
    <svg
      width={width}
      style={style}
      height={height}
      viewBox={viewBox}
      className={className}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(140.564 .1)">
          <mask id="logoMask" fill="#fff">
            <path id="a" d="M.155.082h10.561v10.557H.155z" />
          </mask>
          <path
            d="M10.716 5.36a5.28 5.28 0 0 1-5.283 5.279A5.26 5.26 0 0 1 1.585 8.97 5.278 5.278 0 0 1 5.434.081a5.28 5.28 0 0 1 5.282 5.28"
            fill="#F05A26"
            mask="url(#logoMask)"
          />
        </g>
        <path
          d="M108.545 27.353v13.503h-8.339V27.353a5.159 5.159 0 0 0-10.315 0v13.503h-8.35V27.353c0-7.45 6.04-13.502 13.502-13.502 7.462 0 13.502 6.051 13.502 13.502"
          fill="#FFF"
        />
        <path
          d="M18.647 40.856V27.353c0-.12.001-.24.004-.36a5.157 5.157 0 0 0-5.148-4.792 5.156 5.156 0 0 0-5.153 5.152v13.503H0V27.353c0-7.45 6.04-13.502 13.503-13.502 3.617 0 6.9 1.422 9.323 3.736a13.452 13.452 0 0 1 9.324-3.736c7.461 0 13.502 6.051 13.502 13.502v13.503h-8.34V27.353a5.158 5.158 0 0 0-10.31-.233c.002.078.003.155.003.233v13.503h-8.358z"
          fill="#F05A26"
        />
        <path
          d="M50.093 28.464V14.96h8.34v13.503a5.158 5.158 0 0 0 10.315 0V14.96h8.35v13.503c0 7.45-6.04 13.502-13.502 13.502-7.462 0-13.503-6.052-13.503-13.502m91.73 12.393h8.351V13.85h-8.35zm-15.722 0h-13.114v-8.34H126.1a5.159 5.159 0 0 0 0-10.315h-13.114v-8.35H126.1c7.45 0 13.502 6.04 13.502 13.502 0 7.462-6.051 13.503-13.502 13.503"
          fill="#FFF"
        />
      </g>
    </svg>
  )

  return logo
}

export default Logo
